angular.module('app').directive('whatsappLink', function($sce) {
	return {
        restrict: 'E',
        template: `
            <a ng-if="isWhastappNumber()" title="Enviar mensagem para {{ngModel}} via WhastApp" target="_blank" href="{{getHref()}}">
                <img src="/assets/img/whatsapp-logo-20px.png" style="height:15px; width:15px;"/> 
            </a> <span ng-if="!onlyIcon">{{ngModel}}</span>
        `,
        scope: {
            ngModel: '=?',
            onlyIcon: '=?'
        },
        controller: function($scope, $element, $http, $timeout, $compile) {
            $scope.getHref = function(){
                $scope.href = 'https://web.whatsapp.com/send?phone='+$scope.getTelCleared()+'&text=Olá! ';
                return $scope.href;
            };

            $scope.isWhastappNumber = function(){
                return $scope.getTelCleared()>0;
            };

            $scope.getTelCleared = function(){
                var tel = String($scope.ngModel).replace(/[^0-9]/g, '');
                
                if(tel.length === 0) return '';

                while(tel[0] === '0'){
                    tel = tel.substr(1);
                }

                switch(tel.length){
                    case 8:
                    case 9:
                    case 10:
                    case 11:
                        tel = '55'+tel;
                    break;
                    case 13:
                    break;
                    default:
                        tel = '';
                    break;
                }
                return tel;
            };

        },
        link: function ($scope, $element, attrs, ctrl) {
            
            if(!attrs['ngModel']){
                $scope.ngModel = attrs['tel'];
            }
            
        }
    };
});